<style lang="scss" scoped>
.logs-dialog {
	&__console {
		background: #21252b;
		border-radius: 10px;
		margin-top: 20px;
		padding: 20px;
		&__container {
			height: 600px;
			overflow: scroll;
		}
		&__row {
			line-height: 26px;
			color: darken(white, 20);
			@include flex-center;
			&__date {
				margin-right: 10px;
				color: #cc99cd;
			}
			&__action {
				margin-right: 10px;
			}
			&__name {
				margin-right: 10px;
				font-weight: 600;
				color: #f08d49;
			}
			&__id {
				font-weight: 200;
				color: grey;
			}
			&__help i.el-icon-question {
				color: orange;
				margin-left: 5px;
			}
		}
	}
	&__panel {
		margin-top: 20px;
	}
}
</style>
<template lang="pug">
.logs-dialog
	el-dialog(:visible.sync="dialogVisible", @close="closeDialog")
		.logs-dialog__panel
			.logs-dialog__progess
				el-progress(:percentage="syncPercent", :color="syncColor", :text-inside="true", :stroke-width="18", text-color="#fff")
			.logs-dialog__console
				.logs-dialog__console__container(ref="scroll")
					.logs-dialog__console__row(v-for="log in logsOrdered")
						.logs-dialog__console__row__date {{ log.created_at | date_and_time }}
						.logs-dialog__console__row__action {{ log.type | unslug | past_tense | capitalize }}
						.logs-dialog__console__row__name {{ log.name }}
						.logs-dialog__console__row__id(v-show="log.type === 'error'") [{{ log.id }}]
						.logs-dialog__console__row__help(v-show="log.message && log.message.includes('Precondition check failed')")
							a(href="https://edusync.zendesk.com/hc/en-gb/articles/13849027211805--Precondition-check-failed-error-when-provisioning-Classroom-memberships-Google", target="_blank")
								i.el-icon-question
	
</template>

<script>
import gql from "graphql-tag";

export default {
	props: {
		isDialogVisible: Boolean,
		workLength: Number,
		uuid: String,
	},
	components: {
	
	},
	data() {
		return {
			loading: false,
			latestId: "",
			itemCount: 0,
			logs: [],
			dialogVisible: this.isDialogVisible,
		};
	},
	computed: {
		syncPercent() {
			if (this.hasFinished) {
				return 100;
			} else if (this.itemCount && this.workLength) {
				const percent = Math.floor((this.itemCount / this.workLength) * 100)
				return percent > 98 ? 98: percent;
			} else {
				return 0;
			}
		},
		hasFinished() {
			return !_.isEmpty(this.uuid) && !_.isEmpty(_.find(this.logs, { type: "class_management_finish" }));
		},
		syncColor() {
			return this.hasFinished ? "#34a853" : "#4285f4";
		},
		logsOrdered() {
			return _.sortBy(this.logs, "created_at");
		},
	},
	apollo: {
		logs: {
			query: gql`
				query GetActivities($uuid: String!, $latestId: String!) {
					Activities(uuid: $uuid, latestId: $latestId) {
						id
						type
						name
						message
						code
						created_at
					}
				}
			`,
			pollInterval: 3000,
			fetchPolicy: "no-cache",
			update(r) {
				if (r.Activities && r.Activities.length) {
					// Store id of the latest activity entry retrieved
					this.latestId = r.Activities[r.Activities.length - 1].id;

					// Update item count
					this.itemCount += r.Activities.length;

					// Cap total results
					const activityLimit = 5000;
					let activity = _.concat(this.logs, r.Activities);
					if (activity.length > activityLimit) {
						activity = _.drop(activity, activity.length - activityLimit);
					}
					this.type = activity[activity.length - 1].type;
					return activity;
				} else {
					return this.logs;
				}
			},
			variables() {
				return {
					uuid: this.uuid,
					latestId: this.latestId,
				};
			},
			skip() {
				return !this.isDialogVisible || _.isEmpty(this.uuid) || this.hasFinished;
			},
		},
	},
	methods: {
		closeDialog() {
			this.$emit("close-logs-dialog");
			this.logs = [];
			this.itemCount = 0;
		}
	},
	watch: {
		isDialogVisible(newVal) {
			this.dialogVisible = newVal;
		}
	}
	
};
</script>

